export const HolidayTreeSVG = () => (
    <svg
      width="20"
      height="22"
      viewBox="0 0 20 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.45569 17.739L6.47037 18.4285H19.9994V17.739H5.45569Z"
        fill="#692020"
        fillOpacity="0.33"
      />
      <path
        d="M12.5586 20.4971H16.6173V21.1866H12.5586V20.4971Z"
        fill="#692020"
        fillOpacity="0.33"
      />
      <path
        d="M11.2056 19.118H17.97V19.8076H11.2056V19.118Z"
        fill="#692020"
        fillOpacity="0.33"
      />
      <path
        d="M16.7282 11.4292C17.9169 12.6409 17.9169 14.6053 16.7282 15.817C15.5394 17.0284 13.612 17.0284 12.4232 15.817C11.2345 14.6053 11.2345 12.6409 12.4232 11.4292C13.612 10.2176 15.5394 10.2176 16.7282 11.4292Z"
        fill="#692020"
        fillOpacity="0.33"
      />
      <path
        d="M3.29574 17.2959C5.29067 13.9193 6.48722 10.1156 6.79063 6.18597L10.4411 9.91873C11.0173 8.75658 10.7994 7.34888 9.89996 6.42406L9.57831 6.09353C9.36411 5.87404 9.11724 5.69012 8.84718 5.54897L12.2428 5.56445C11.8442 4.32713 10.7132 3.48866 9.43549 3.48327L8.97848 3.4812C8.65216 3.4803 8.32801 3.53454 8.01891 3.64197L10.4543 1.16844C9.31409 0.58125 7.93329 0.803303 7.02591 1.71977L6.70163 2.04781C6.4862 2.26585 6.30583 2.51761 6.16741 2.793C6.03089 2.51651 5.85275 2.26316 5.63936 2.0429L5.31758 1.71231C4.41874 0.787481 3.03998 0.552716 1.89474 1.1294L4.30737 3.6247C3.99901 3.51471 3.6752 3.4575 3.34888 3.45529L2.89228 3.45336C1.61486 3.44742 0.47694 4.27517 0.0673111 5.50849L3.46324 5.52403C3.19162 5.6629 2.94332 5.84453 2.72722 6.0621L2.40273 6.39013C1.49542 7.30639 1.26515 8.71174 1.83116 9.87907L5.43132 6.26377C5.18323 10.0411 3.83965 13.658 1.57107 16.6554C1.06173 16.5078 0.543709 16.3938 0.0199968 16.3143L0 20.7957L7.77915 20.83L7.7643 20.8111C6.56307 19.3015 5.03288 18.098 3.29574 17.2959ZM2.36945 20.4624L1.69295 20.4592L1.69593 19.7697L2.37229 19.7728L2.36945 20.4624ZM4.40132 19.7821L3.72489 19.779L3.72821 19.0896L4.40471 19.0926L4.40132 19.7821Z"
        fill="#692020"
        fillOpacity="0.33"
      />
    </svg>
  );
  